// images

import img0 from '../assets/images/N0.jpg';
import img1 from '../assets/images/N1.jpg';
import img2 from '../assets/images/N2.jpg';
import img3 from '../assets/images/N3.jpg';
import img4 from '../assets/images/N4.jpg';
//import img5 from '../assets/images/N5.jpg';
//import img6 from '../assets/images/N6.jpg';
import img7 from '../assets/images/N7.jpg';
import img8 from '../assets/images/N8.jpg';
import img9 from '../assets/images/N9.jpg';
import img10 from '../assets/images/N10.jpg';
import img11 from '../assets/images/N11.jpg';
import img12 from '../assets/images/N12.jpg';
import img13 from '../assets/images/N13.jpg';
import img14 from '../assets/images/N14.jpg';
import img15 from '../assets/images/N15.jpg';
import img16 from '../assets/images/N16.jpg';
import img17 from '../assets/images/N17.jpg';

/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    //////////////////// DORO
 

    {
      headerText: 'No-Filter',
      subHeaderText: [''],
       /*
    .mask-custom {
  backdrop-filter: contrast(100%) brightness(100%) saturate(100%) sepia(0%) hue-rotate(0deg) grayscale(0%) invert(0%) blur(0px);
  mix-blend-mode: normal;
  background: rgba(0, 0, 0, 0.0);
  opacity: 1;
}
*/

      saturate: 100,
      hueRotate: 0,
      brightness: 100,
      filter: `contrast(100%)  saturate(100%) sepia(0%) hue-rotate(0deg) grayscale(0%) invert(0%) blur(0px) saturate(var(--saturate)) hue-rotate(var(--hue-rotate)) brightness(var(--brightness))`,
      mixBlendMode: 'normal',
      background: `rgba(0, 0, 0, 0.0)`,
      opacity: 1,

      hueStep: 20,
      satStep: 10,
      brightStep: 10,
      hueMax: 360,
      satMax: 200,
      brightMax: 200,
    },
   //-------------------------------------------------------------------------
     {
      headerText: 'Aden',
      subHeaderText: ['default: contrast(90%) brightness(120%) saturate(85%) sepia(0%) hue-rotate(20deg) grayscale(0%) invert(0%) blur(0px)  mix-blend-mode: darken;   background: linear-gradient(to right, rgba(66, 10, 14, 0.2) 1, rgba(66, 10, 14, 0)'],
  

      saturate: 85,
      hueRotate: 20,
      brightness: 120,
      filter: `contrast(90%)  saturate(85%) brightness(120%) sepia(0%) hue-rotate(20deg) grayscale(0%) invert(0%) blur(0px) saturate(var(--saturate)) hue-rotate(var(--hue-rotate)) brightness(var(--brightness))`,
      mixBlendMode: 'darken',
      background: `linear-gradient(to right, rgba(66, 10, 14, 0.2) 1, rgba(66, 10, 14, 0))`,
      opacity: 1,

      hueStep: 20,
      satStep: 10,
      brightStep: 10,
      hueMax: 360,
      satMax: 200,
      brightMax: 200,
    },
    //-------------------------------------------------------------------------
     
  ],

  /*****************************************
   * Global variables
   *****************************************/

  images: [
    img0,
    img1,
    img2,
    img3,
    img4,
    // img5,
    //img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
  ],

  exampleIdx: 0,

  imageIdx: 15,
};

/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  selectOptions: [
   'No-filter','Aden'
    // “Amaro”, 
    // “Brannan”,
    //  “Brooklyn”,
   // ” Clarendon”, “Earlybird”,”Gingham”, “Hudson”, “Inkwell”, “Lofi”, “Maven”, “Perpetua”, “Reyes”, “Stinson”, “Toaster”, “Walden”, “Valencia”, “Xpro2"  
  ],

  // input with value
  slideNumber: {
    value: data.imageIdx + 1,
    step: 1,
    min: 1,
    max: data.images.length - 1,
    label: '',
  },
};

export default data;
